import WidgetBase from '@dojo/widget-core/WidgetBase';
import { v } from '@dojo/widget-core/d';

import * as css from './styles/Ticker.m.css';

import Ticker from './Ticker';

const icon_clock_k  = require('./../img/clock-black.png');

export interface GameTimeScoreParent {
    parent: Ticker;
}

export class GameTimeScoreWidget extends WidgetBase<GameTimeScoreParent> {
    
    constructor() {
        super();
    }
    
    protected render() {
        this.properties.parent.gametimewidget=this;
        
        return v('div', { classes: [ css.box, css.timeresult ] }, [
            v('div', { classes: [ css.timeresulttime] }, [ 
                v('img', { classes: css.timeresultclock, src: icon_clock_k }),
                this.properties.parent.game_time
            ]),
            v('div', { classes: [ css.timeresultscore] }, [ this.properties.parent.home_score, ":", this.properties.parent.guest_score ]),
        ]);
    }
}

export default GameTimeScoreWidget;


// WEBPACK FOOTER //
// ./node_modules/@dojo/webpack-contrib/css-module-dts-loader?type=ts&instanceName=0_dojo!./src/widgets/GameTimeScoreWidget.ts